import React from 'react';
import PropTypes from 'prop-types';
import {
  find,
  isEmpty,
  map,
  orderBy,
} from 'lodash';
import { dayDisplayName, formatDuration } from '../utils';
import { CLOSED_DAY } from '../constants';

const HoursOfOperationDay = ({ day, hours }) => {
  const { hours_of_operation } = find(hours, { day_of_week: day }) || {};
  const hoursDisplay = map(
    orderBy(hours_of_operation, 'opens_at'),
    formatDuration,
  ).join(', ');

  return (
    <div className="ui-hours-of-operation-day">
      <div className="ui-hours-of-operation-day__day-label">
        <p>{dayDisplayName(day)}</p>
      </div>
      <p className="ui-hours-of-operation-day__hours">
        {
          isEmpty(hours_of_operation) ? CLOSED_DAY : hoursDisplay
        }
      </p>
    </div>
  );
};

HoursOfOperationDay.propTypes = {
  day: PropTypes.string.isRequired,
  hours: PropTypes.arrayOf(
    PropTypes.shape({
      day_of_week: PropTypes.string.isRequired,
      hours_of_operation: PropTypes.arrayOf(
        PropTypes.shape({
          closes_at: PropTypes.number,
          opens_at: PropTypes.number,
        }),
      ).isRequired,
    }).isRequired,
  ).isRequired,
};

export default HoursOfOperationDay;



// WEBPACK FOOTER //
// ./public/js/components/HoursOfOperation/components/HoursOfOperationDay.jsx